<template>
  <main class="main-content">
    <Menu />
    <div class="body-content">
      <RouterView />
      <Footer />
    </div>
  </main>
</template>

<script setup lang="ts">
  import Menu from '../components/MenuComponent.vue';
  import Footer from '../components/FooterComponent.vue';
</script>

<style scoped>
  .body-content {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow-y: auto !important;
    height: inherit;
  }
</style>